﻿<script setup>
    import DataSetService from '@/common/data/DataSetService.js';

    const props = defineProps({
        ds: String,
        sort: String,
        sortDir: String,
        pageSize: Number,
        search: Object,
        showPager: {
            type: Boolean,
            default: true
        }
    });

    const ds = ref(
        DataSetService.CreateDataSet(
            props.ds,
            props.sort,
            props.sortDir,
            props.pageSize
        )
    )

    async function getDataSet() {
        ds.value.PS.Search = props.search;
        ds.value = await DataSetService.GetDataSet(props.ds, ds.value.PS);
    }

    async function prevPage() {
        ds.value.PS.Pager.PageIndex -= 1;
        ds.value = await DataSetService.UpdateDataSet(ds.value);
    }
    async function nextPage() {
        ds.value.PS.Pager.PageIndex += 1;
        ds.value = await DataSetService.UpdateDataSet(ds.value);
    }

    watch(
        () => props.search,
        (newVal, oldVal) => getDataSet(),
        { deep: true }
    );

    defineExpose({
        getDataSet
    });

    getDataSet();
</script>

<template>
    <slot></slot>
    <div v-for="r in ds.Results">
        <slot name="result" v-bind="{r}"></slot>
    </div>
    <div grid grid-cols-2 border-t v-if="showPager && ds.PS.Pager.PageCount">
        <div leading-9>
            {{ds.PS.Pager.PageIndex}} / {{ds.PS.Pager.PageCount}}
        </div>
        <div text-right>
            <q-btn-group flat>
                <q-btn flat
                       color="primary"
                       icon="arrow_left"
                       @click="prevPage"
                       :disable="ds.PS.Pager.PageIndex == 1" />
                <q-btn flat
                       color="primary"
                       icon="arrow_right"
                       @click="nextPage"
                       :disable="ds.PS.Pager.PageIndex == ds.PS.Pager.PageCount" />
            </q-btn-group>
        </div>
    </div>
</template>